(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('InsuranceLevelDetailController', InsuranceLevelDetailController);

    InsuranceLevelDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'InsuranceLevel', 'Insurance', 'Corporation'];

    function InsuranceLevelDetailController($scope, $rootScope, $stateParams, previousState, entity, InsuranceLevel, Insurance, Corporation) {
        var vm = this;

        vm.insuranceLevel = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:insuranceLevelUpdate', function(event, result) {
            vm.insuranceLevel = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
